import React from "react";
import PropTypes from "prop-types"; // PropTypes 추가
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";

const DialogAlert = ({ open, onClose, title, message }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          color="primary"
          sx={{ color: "#fff" }} // 텍스트 색상을 흰색으로 설정
          variant="contained"
        >
          확인
        </Button>
      </DialogActions>
    </Dialog>
  );
};

// defaultProps 설정
DialogAlert.defaultProps = {
  open: false,
  title: "알림",
  message: "",
  onClose: () => {},
};

// propTypes 설정
DialogAlert.propTypes = {
  open: PropTypes.bool, // Dialog가 열려 있는지 여부
  onClose: PropTypes.func, // Dialog를 닫는 함수
  title: PropTypes.string, // Dialog 제목
  message: PropTypes.string, // Dialog 메시지
};

export default DialogAlert;
